/* eslint-disable @next/next/no-img-element */
import React, { useState, useEffect, useCallback } from "react";
import { Block } from "@xprog/prensa";
import useEmblaCarousel from "embla-carousel-react";

type Game = {
  name: string;
  slotTemplateCode: string;
  icons: string[];
};

type JogosWidgetWrapperProps = {
  data: any[];
};

const JogosWidgetWrapper: React.FC<JogosWidgetWrapperProps> = ({ data }) => {
  const [games, setGames] = useState<Game[]>([]);
  const [emblaRef, emblaApi] = useEmblaCarousel({ loop: false });

  const gameCardStyle: React.CSSProperties = {
    minWidth: "100%",
    padding: "16px",
    background: "#f9f9f9",
    borderRadius: "10px",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    boxShadow: "0 2px 6px rgba(0,0,0,0.08)",
  };

  const gameTitleStyle: React.CSSProperties = {
    fontFamily: 'Roboto Slab, sans-serif',
    fontSize: 16,
    textTransform: "uppercase",
    fontWeight: "bold",
    overflow: "hidden",
    maxWidth: "100%",
    textAlign: "center",
    marginTop: 8,
    marginBottom: 16,
  };

  const gameDetailsStyle: React.CSSProperties = {
    fontFamily: 'Roboto Slab, sans-serif',
    fontSize: 12,
    fontWeight: "bold",
    overflow: "hidden",
    maxWidth: "100%",
    textAlign: "center",
    marginTop: 8,
    marginBottom: 16,
  };

  const gameVersusStyle: React.CSSProperties = {
    fontFamily: 'sans-serif',
    fontSize: 28,
    color: "#777",
  };

  const gameBottonLeftStyle: React.CSSProperties = {
    position: "absolute",
    left: 0,
    top: "50%",
    transform: "translateY(-50%)",
    background: "white",
    border: "1px solid #ccc",
    borderRadius: "50%",
    width: 40,
    height: 40,
    cursor: "pointer",
    zIndex: 2
  };

  const gameBottonRightStyle: React.CSSProperties = {
    position: "absolute",
    right: 0,
    top: "50%",
    transform: "translateY(-50%)",
    background: "white",
    border: "1px solid #ccc",
    borderRadius: "50%",
    width: 40,
    height: 40,
    cursor: "pointer",
    zIndex: 2
  };

  useEffect(() => {
    if (data && data.length > 0) {
      const parsedGames = data.map((item: any) => {
        const child = item.props.children[0];
        const icons = child.props.contentData?.map((c) => c.url.replace("jpg", "png")) || [];

        return {
          name: child.props.name,
          slotTemplateCode: child.props.slotTemplateCode,
          icons,
        };
      });

      setGames(parsedGames);
    }
  }, [data]);

  const scrollPrev = useCallback(() => emblaApi?.scrollPrev(), [emblaApi]);
  const scrollNext = useCallback(() => emblaApi?.scrollNext(), [emblaApi]);

  return (
    <Block as="div" css={{ position: "relative", padding: "20px", overflow: "hidden" }}>
      {/* Botões Laterais */}
      <button
        onClick={scrollPrev}
        style={gameBottonLeftStyle}
      >
        ◀
      </button>

      <button
        onClick={scrollNext}
        style={gameBottonRightStyle}
      >
        ▶
      </button>

      <div ref={emblaRef} style={{ overflow: "hidden" }}>
        <div style={{ display: "flex", gap: 16 }}>
          {games.map((game, index) => (
            <div
              key={index}
              style={gameCardStyle}
            >
              <h4 style={gameTitleStyle}>{game.name}</h4>
              {game.icons.length >= 2 && (
                <div style={{ display: "flex", alignItems: "center", gap: 16 }}>
                  <img
                    src={game.icons[0]}
                    alt="Time A"
                    height={80}
                  />
                  <span style={gameVersusStyle}>X</span>
                  <img
                    src={game.icons[1]}
                    alt="Time B"
                    height={80}
                  />
                </div>
              )}
              <span style={gameDetailsStyle}>{game.slotTemplateCode}</span>
            </div>
          ))}
        </div>
      </div>
    </Block>
  );
};

export default JogosWidgetWrapper;
